/**
 * Đường dẫn route frontend — dùng cho Link, navigate, ProtectedRoute.
 *
 * APP_ROUTES: path đầy đủ (có thể có hàm động).
 * ROUTE_PATHS: segment tương đối cho cấu hình nested routes.
 */

/** Route công khai và admin — path tuyệt đối */
export const APP_ROUTES = {
  home: '/',
  properties: '/properties',
  propertyDetails: (propertyId = ':id') => `/properties/${propertyId}`,
  profile: '/profile',
  favorites: '/favorites',
  login: '/login',
  register: '/register',
  admin: '/admin',
  adminProperties: '/admin/properties',
  adminPropertyNew: '/admin/properties/new',
  adminPropertyEdit: (propertyId = ':id') => `/admin/properties/${propertyId}/edit`,
  adminContacts: '/admin/contacts',
  adminUsers: '/admin/users/admins',
  adminManagedUsers: '/admin/users',
};

/** Segment route tương đối — dùng trong AppRoutes nested config */
export const ROUTE_PATHS = {
  root: '/',
  wildcard: '*',
  adminProperties: 'properties',
  propertyDetails: 'properties/:id',
  adminPropertyEdit: 'properties/:id/edit',
  adminPropertyNew: 'properties/new',
  adminContacts: 'contacts',
  adminUsers: 'users/admins',
  adminManagedUsers: 'users',
};
